var _g, _path, _mask, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_76_8119)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 41.5,
    r: 40.5,
    fill: "white",
    fillOpacity: 0.45
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 41L32.5 55.7224L32.5 26.2776L58 41Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_76_8119",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 82C50.872 82 60.8487 78.0206 68.3735 70.8823C75.8983 63.7439 80.3976 53.9906 80.9438 43.6329C81.49 33.2753 78.0416 23.1029 71.3094 15.2126C64.5772 7.3223 55.0744 2.31563 44.7599 1.22466L44.4505 4.15075C54.0156 5.16245 62.828 9.80538 69.0711 17.1224C75.3142 24.4394 78.512 33.8728 78.0055 43.478C77.4989 53.0831 73.3265 62.1278 66.3484 68.7476C59.3704 75.3673 50.1185 79.0576 40.5 79.0576V82Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 82C50.872 82 60.8487 78.0206 68.3735 70.8823C75.8983 63.7439 80.3976 53.9906 80.9438 43.6329C81.49 33.2753 78.0416 23.1029 71.3094 15.2126C64.5772 7.3223 55.0744 2.31563 44.7599 1.22466L44.4505 4.15075C54.0156 5.16245 62.828 9.80538 69.0711 17.1224C75.3142 24.4394 78.512 33.8728 78.0055 43.478C77.4989 53.0831 73.3265 62.1278 66.3484 68.7476C59.3704 75.3673 50.1185 79.0576 40.5 79.0576V82Z",
    fill: "#D9D9D9",
    stroke: "#02C037",
    strokeWidth: 8,
    mask: "url(#path-3-inside-1_76_8119)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58 42L32.5 56.7224L32.5 27.2776L58 42Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_76_8119",
    x: -23,
    y: -22,
    width: 127,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_76_8119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_76_8119",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.df3c6c7b56b61d19e924fb6643ebcac7.svg";
export { ForwardRef as ReactComponent };